import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngxs/store'
import { RouteName } from '../enums/route-name.enum'
import { isNativeDevice } from '../helpers/is-native-device'
import { isForcedResolution } from '../helpers/is-forced-resolutions'
import { UserState } from '../../store/user/user.state'

export function nativeDeviceGuard() {
  if (isNativeDevice() && !(isForcedResolution() === false)) {
    const isUserAdmin = inject(Store).selectSignal(UserState.isUserAdmin)
    inject(Router).navigateByUrl(
      '/' + isUserAdmin() ? RouteName.RpmTabletDashboard : RouteName.Reports
    )
    return false
  }
  return true
}
